<div class="toolbar">
  <span>
    <button matButton="text" [disabled]="isBusy()" (click)="goToOrderMaster()">
      <span>
        <mat-icon class="size-16">keyboard_arrow_left</mat-icon>
        <label>Back To Orders</label>
      </span>
    </button>
  </span>
  <span class="spacer"></span>
  <button class="primary-button" matButton="elevated" [disabled]="!releaseResults() || releaseResults().length === 0"
    (click)="exportToExcel()">Export to Excel
  </button>
  <span class="spacer"></span>
</div>
@if (errorMessage()) {
  <div class="errorMessage">
    {{ errorMessage() }}
  </div>
}
<div>
  @if (isBusy()) {
    <div class="busyIndicator">
      <mat-progress-spinner diameter="24" mode="indeterminate" strokeWidth="1"></mat-progress-spinner>
      <label class="busyLabel">Please Wait...</label>
    </div>
  }
  @if (releaseResults()) {
    <div class="results">
      <table class="resultsTable">
        <thead>
          <tr>
            <td class="tableCell centeredCell headerCell">Recent Releases</td>
          </tr>
        </thead>
      </table>
      <table class="resultsTable">
        <thead>
          <tr>
            <td class="tableCell centeredCell headerCell clickableCell" (click)="sortResults('ENTITY_ID')">
              <span>
                <label>Release ID</label>
                @if (criteria.sortColumn == 'ENTITY_ID') {
                  <span>
                    @if (!isDescending()) {
                      <mat-icon class="size-16">keyboard_arrow_up</mat-icon>
                    }
                    @if (isDescending()) {
                      <mat-icon class="size-16">keyboard_arrow_down</mat-icon>
                    }
                  </span>
                }
              </span>
            </td>
            <td class="tableCell centeredCell headerCell clickableCell" (click)="sortResults('PROJECT_NAME')">
              <span>
                <label>Project</label>
                @if (criteria.sortColumn == 'PROJECT_NAME') {
                  <span>
                    @if (!isDescending()) {
                      <mat-icon class="size-16">keyboard_arrow_up</mat-icon>
                    }
                    @if (isDescending()) {
                      <mat-icon class="size-16">keyboard_arrow_down</mat-icon>
                    }
                  </span>
                }
              </span>
            </td>
            <td class="tableCell centeredCell headerCell clickableCell" (click)="sortResults('LAST_UPDATE_DATE')">
              <span>
                <label>Last Update</label>
                @if (criteria.sortColumn == 'LAST_UPDATE_DATE') {
                  <span>
                    @if (!isDescending()) {
                      <mat-icon class="size-16">keyboard_arrow_up</mat-icon>
                    }
                    @if (isDescending()) {
                      <mat-icon class="size-16">keyboard_arrow_down</mat-icon>
                    }
                  </span>
                }
              </span>
            </td>
            <td class="tableCell centeredCell headerCell clickableCell" (click)="sortResults('FINAL_EXTENDED_AMOUNT')">
              <span>
                <label>Amount</label>
                @if (criteria.sortColumn == 'FINAL_EXTENDED_AMOUNT') {
                  <span>
                    @if (!isDescending()) {
                      <mat-icon class="size-16">keyboard_arrow_up</mat-icon>
                    }
                    @if (isDescending()) {
                      <mat-icon class="size-16">keyboard_arrow_down</mat-icon>
                    }
                  </span>
                }
              </span>
            </td>
            <td class="tableCell centeredCell headerCell clickableCell" (click)="sortResults('UNIT_QUANTITY')">
              <span>
                <label>Qty</label>
                @if (criteria.sortColumn == 'UNIT_QUANTITY') {
                  <span>
                    @if (!isDescending()) {
                      <mat-icon class="size-16">keyboard_arrow_up</mat-icon>
                    }
                    @if (isDescending()) {
                      <mat-icon class="size-16">keyboard_arrow_down</mat-icon>
                    }
                  </span>
                }
              </span>
            </td>
            <td class="tableCell centeredCell headerCell clickableCell" (click)="sortResults('LEAD_TIME')">
              <span>
                <label>Lead Time</label>
                @if (criteria.sortColumn == 'LEAD_TIME') {
                  <span>
                    @if (!isDescending()) {
                      <mat-icon class="size-16">keyboard_arrow_up</mat-icon>
                    }
                    @if (isDescending()) {
                      <mat-icon class="size-16">keyboard_arrow_down</mat-icon>
                    }
                  </span>
                }
              </span>
            </td>
            <td class="tableCell centeredCell headerCell clickableCell" (click)="sortResults('RELEASE_NUMBER')">
              <span>
                <label>IEC Release #</label>
                @if (criteria.sortColumn == 'RELEASE_NUMBER') {
                  <span>
                    @if (!isDescending()) {
                      <mat-icon class="size-16">keyboard_arrow_up</mat-icon>
                    }
                    @if (isDescending()) {
                      <mat-icon class="size-16">keyboard_arrow_down</mat-icon>
                    }
                  </span>
                }
              </span>
            </td>
            <td class="tableCell centeredCell headerCell clickableCell" (click)="sortResults('STATUS')">
              <span>
                <label>Status</label>
                @if (criteria.sortColumn == 'STATUS') {
                  <span>
                    @if (!isDescending()) {
                      <mat-icon class="size-16">keyboard_arrow_up</mat-icon>
                    }
                    @if (isDescending()) {
                      <mat-icon class="size-16">keyboard_arrow_down</mat-icon>
                    }
                  </span>
                }
              </span>
            </td>
            <td class="tableCell centeredCell headerCell clickableCell" (click)="sortResults('REVIEW_STATUS')">
              <span>
                <label>Review Status</label>
                @if (criteria.sortColumn == 'REVIEW_STATUS') {
                  <span>
                    @if (!isDescending()) {
                      <mat-icon class="size-16">keyboard_arrow_up</mat-icon>
                    }
                    @if (isDescending()) {
                      <mat-icon class="size-16">keyboard_arrow_down</mat-icon>
                    }
                  </span>
                }
              </span>
            </td>
            <td class="tableCell centeredCell headerCell clickableCell" (click)="sortResults('MILESTONE')">
              <span>
                <label>Milestone</label>
                @if (criteria.sortColumn == 'MILESTONE') {
                  <span>
                    @if (!isDescending()) {
                      <mat-icon class="size-16">keyboard_arrow_up</mat-icon>
                    }
                    @if (isDescending()) {
                      <mat-icon class="size-16">keyboard_arrow_down</mat-icon>
                    }
                  </span>
                }
              </span>
            </td>
            <td class="tableCell centeredCell headerCell clickableCell" (click)="sortResults('ERP_STATUS')">
              <span>
                <label>ERP Status</label>
                @if (criteria.sortColumn == 'ERP_STATUS') {
                  <span>
                    @if (!isDescending()) {
                      <mat-icon class="size-16">keyboard_arrow_up</mat-icon>
                    }
                    @if (isDescending()) {
                      <mat-icon class="size-16">keyboard_arrow_down</mat-icon>
                    }
                  </span>
                }
              </span>
            </td>
            <td class="tableCell centeredCell headerCell clickableCell" (click)="sortResults('SCHEDULE_DATE')">
              <span>
                <label>Schedule Dt</label>
                @if (criteria.sortColumn == 'SCHEDULE_DATE') {
                  <span>
                    @if (!isDescending()) {
                      <mat-icon class="size-16">keyboard_arrow_up</mat-icon>
                    }
                    @if (isDescending()) {
                      <mat-icon class="size-16">keyboard_arrow_down</mat-icon>
                    }
                  </span>
                }
              </span>
            </td>
            <td class="tableCell centeredCell headerCell clickableCell" (click)="sortResults('TRUCKING_COMPANY')">
              <span>
                <label>Last Ship Via</label>
                @if (criteria.sortColumn == 'TRUCKING_COMPANY') {
                  <span>
                    @if (!isDescending()) {
                      <mat-icon class="size-16">keyboard_arrow_up</mat-icon>
                    }
                    @if (isDescending()) {
                      <mat-icon class="size-16">keyboard_arrow_down</mat-icon>
                    }
                  </span>
                }
              </span>
            </td>
            <td class="tableCell centeredCell headerCell clickableCell" (click)="sortResults('TRACKING_NUMBER')">
              <span>
                <label>Last Tracking #</label>
                @if (criteria.sortColumn == 'TRACKING_NUMBER') {
                  <span>
                    @if (!isDescending()) {
                      <mat-icon class="size-16">keyboard_arrow_up</mat-icon>
                    }
                    @if (isDescending()) {
                      <mat-icon class="size-16">keyboard_arrow_down</mat-icon>
                    }
                  </span>
                }
              </span>
            </td>
          </tr>
        </thead>
        @for (result of releaseResults(); track result; let rowIndex = $index) {
          <tr>
            <td class="tableCell">{{ result.id.entityId }};{{ result.id.entityRevision }}</td>
            <td class="tableCell">{{ result.projectName }}</td>
            <td class="tableCell">{{ result.lastUpdateDate | date: 'MM/dd/yyyy':'UTC' }}</td>
            <td class="tableCell">{{ result.finalExtendedAmount | currency:'USD' }}</td>
            <td class="tableCell">{{ result.totalUnitQty }}</td>
            <td class="tableCell">{{ result.leadTime }}</td>
            <td class="tableCell">{{ result.releaseNumber }}</td>
            <td class="tableCell">{{ result.statusDescription }}</td>
            <td class="tableCell">{{ result.reviewStatus }}</td>
            <td class="tableCell">{{ result.milestone }}</td>
            <td class="tableCell">{{ result.erpStatus }}</td>
            <td class="tableCell">{{ result.estimatedScheduleDate | date: 'MM/dd/yyyy':'UTC' }}</td>
            <td class="tableCell">{{ result.truckingCompany }}</td>
            <td class="tableCell">{{ result.trackingNumber }}</td>
          </tr>
        }
      </table>
    </div>
  }
  @if (maxPage() > 1) {
    <div class="resultNavigation toolbar">
      <span class="spacer"></span>
      <span>
        <button matButton="text" [disabled]="isBusy() || criteria.pageNumber === 1" (click)="previousPage()">
          <span>
            <mat-icon class="size-16">keyboard_arrow_left</mat-icon>
            <label>Previous</label>
          </span>
        </button>
        <label class="paginationStatus">Page {{ criteria.pageNumber }} of {{ maxPage() }}</label>
        <button matButton="text" [disabled]="isBusy() || criteria.pageNumber >= maxPage()" (click)="nextPage()">
          <span>
            <mat-icon class="size-16">keyboard_arrow_right</mat-icon>
            <label>Next</label>
          </span>
        </button>
      </span>
      <span class="spacer"></span>
    </div>
  }
</div>
